import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const ChevronDown = ({
  size = 24,
  style = {},
  color = "currentColor",
}: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 14.0858L6.70711 8.79289C6.31658 8.40237 5.68342 8.40237 5.29289 8.79289C4.90237 9.18342 4.90237 9.81658 5.29289 10.2071L11.2929 16.2071C11.6834 16.5976 12.3166 16.5976 12.7071 16.2071L18.7071 10.2071C19.0976 9.81658 19.0976 9.18342 18.7071 8.79289C18.3166 8.40237 17.6834 8.40237 17.2929 8.79289L12 14.0858Z"
        fill={color}
      />
      <mask
        id="mask0_13_5482"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="8"
        width="14"
        height="9"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 14.0858L6.70711 8.79289C6.31658 8.40237 5.68342 8.40237 5.29289 8.79289C4.90237 9.18342 4.90237 9.81658 5.29289 10.2071L11.2929 16.2071C11.6834 16.5976 12.3166 16.5976 12.7071 16.2071L18.7071 10.2071C19.0976 9.81658 19.0976 9.18342 18.7071 8.79289C18.3166 8.40237 17.6834 8.40237 17.2929 8.79289L12 14.0858Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_13_5482)"></g>
    </svg>
  );
};

export default ChevronDown;
